/**
 * Options for the cost overview filter bar, in the shape gpd-filter expects ({ label, value }).
 *
 * The page stores its filters as the same 0/1/2 codes the segmented switches used, so the
 * helpers in beauftragt-filter.ts and amount-basis.ts keep working untouched - and anyone who
 * had a filter set before this bar existed still finds it set afterwards. These functions are
 * only the translation between a code and the array of ticked values a gpd-filter hands back.
 */

export interface FilterItem {
  label: string;
  value: number;
}

/** A one-item list, so the pill behaves exactly like the pipeline's "Meine Ansicht". */
export const MY_COSTS_FILTER_ITEMS: FilterItem[] = [
  { label: $localize`:@@myCosts:My Costs`, value: 1 },
];

/** No "Alle" entry: everything ticked already means all, which is also the default. */
export const BEAUFTRAGT_FILTER_ITEMS: FilterItem[] = [
  { label: $localize`:@@commissioned:Commissioned`, value: 1 },
  { label: $localize`:@@notCommissioned:Not commissioned`, value: 2 },
];

export const AMOUNT_BASIS_FILTER_ITEMS: FilterItem[] = [
  { label: $localize`:@@gross:Gross`, value: 0 },
  { label: $localize`:@@nett:Nett`, value: 1 },
];

/**
 * Both ticked is "all", and so is nothing ticked: emptying a filter reads as an empty page for
 * no visible reason, which is the same call setDebitorFilter already makes for the Gesellschaft list.
 */
export function beauftragtSelectionToCode(selection: number[]): number {
  return selection?.length === 1 ? selection[0] : 0;
}

export function beauftragtCodeToSelection(code: number): number[] {
  return code === 1 || code === 2 ? [code] : [1, 2];
}

export function amountBasisSelectionToCode(selection: number[]): number {
  return selection?.length ? selection[0] : 0;
}

/** Nothing ticked = every cost. */
export function myCostsSelectionToRequest(selection: number[]): boolean {
  return selection?.includes(1) ?? false;
}

/**
 * The toggle this filter replaced stored "true"/"false" under the same key. Read those back
 * rather than silently resetting everyone who had it on when this shipped.
 */
export function readStoredMyCosts(raw: string | null): number[] {
  return raw === 'true' || raw === '1' ? [1] : [];
}
